/**
 * Module-level state for the playlist asset picker's last browsed folder path.
 * Extracted to its own file so logout.ts can reset it without importing
 * the heavy AssetPickerPanel (which pulls in Uppy, dnd-kit, etc.).
 */
let lastPickerPath = '/';

export function getPickerPath() {
  return lastPickerPath;
}

export function setPickerPath(path: string) {
  lastPickerPath = path;
}

/** Resets the picker path to root. Called on logout to prevent cross-account path leakage. */
export function resetPickerPath() {
  lastPickerPath = '/';
}
